module.exports = __webpack_public_path__ + "img/Mobile_Process-Graphic.85a759f4.svg";